import HijriDate from 'hijri-converter';
import jalaali from 'jalaali-js';

// ── Translation Tables ───────────────────────────────

const DAY_NAMES = {
  en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  ar: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
  fa: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
  tr: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
  id: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
  ms: ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'],
};

const GREGORIAN_MONTHS = {
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  ar: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
  fa: ['ژانویه', 'فوریه', 'مارس', 'آوریل', 'مه', 'ژوئن', 'ژوئیه', 'اوت', 'سپتامبر', 'اکتبر', 'نوامبر', 'دسامبر'],
  ur: ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'],
  tr: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
  id: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
  ms: ['Januari', 'Februari', 'Mac', 'April', 'Mei', 'Jun', 'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember'],
};

const HIJRI_MONTHS = {
  en: ['Muharram', 'Safar', 'Rabi al-Awwal', 'Rabi al-Thani', 'Jumada al-Awwal', 'Jumada al-Thani', 'Rajab', "Sha'ban", 'Ramadan', 'Shawwal', "Dhul-Qa'dah", 'Dhul-Hijjah'],
  ar: ['محرم', 'صفر', 'ربيع الأول', 'ربيع الثاني', 'جمادى الأولى', 'جمادى الآخرة', 'رجب', 'شعبان', 'رمضان', 'شوال', 'ذو القعدة', 'ذو الحجة'],
  fa: ['محرم', 'صفر', 'ربیع‌الاول', 'ربیع‌الثانی', 'جمادی‌الاول', 'جمادی‌الثانی', 'رجب', 'شعبان', 'رمضان', 'شوال', 'ذیقعده', 'ذیحجه'],
  ur: ['محرم', 'صفر', 'ربیع الاول', 'ربیع الثانی', 'جمادی الاول', 'جمادی الثانی', 'رجب', 'شعبان', 'رمضان', 'شوال', 'ذوالقعدہ', 'ذوالحجہ'],
  tr: ['Muharrem', 'Safer', 'Rebiülevvel', 'Rebiülahir', 'Cemaziyelevvel', 'Cemaziyelahir', 'Recep', 'Şaban', 'Ramazan', 'Şevval', 'Zilkade', 'Zilhicce'],
  id: ['Muharram', 'Safar', 'Rabiul Awal', 'Rabiul Akhir', 'Jumadil Awal', 'Jumadil Akhir', 'Rajab', 'Syakban', 'Ramadan', 'Syawal', 'Zulkaidah', 'Zulhijah'],
  ms: ['Muharram', 'Safar', 'Rabiulawal', 'Rabiulakhir', 'Jamadilawal', 'Jamadilakhir', 'Rejab', 'Syaaban', 'Ramadan', 'Syawal', 'Zulkaedah', 'Zulhijah'],
};

const PERSIAN_MONTHS = {
  en: ['Farvardin', 'Ordibehesht', 'Khordad', 'Tir', 'Mordad', 'Shahrivar', 'Mehr', 'Aban', 'Azar', 'Dey', 'Bahman', 'Esfand'],
  fa: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
  ur: ['فروردین', 'اردیبہشت', 'خرداد', 'تیر', 'مرداد', 'شہریور', 'مہر', 'آبان', 'آذر', 'دی', 'بہمن', 'اسفند'],
  ar: ['فروردين', 'أرديبهشت', 'خرداد', 'تير', 'مرداد', 'شهريور', 'مهر', 'آبان', 'آذر', 'دي', 'بهمن', 'إسفند'],
  tr: ['Ferverdin', 'Ordibeheşt', 'Hordad', 'Tir', 'Mordad', 'Şehriver', 'Mehr', 'Aban', 'Azar', 'Dey', 'Bahmen', 'Esfend'],
  id: ['Farvardin', 'Ordibehesht', 'Khordad', 'Tir', 'Mordad', 'Shahrivar', 'Mehr', 'Aban', 'Azar', 'Dey', 'Bahman', 'Esfand'],
  ms: ['Farvardin', 'Ordibehesht', 'Khordad', 'Tir', 'Mordad', 'Shahrivar', 'Mehr', 'Aban', 'Azar', 'Dey', 'Bahman', 'Esfand'],
};

// RTL languages use the Arabic comma separator
const SEP = (lang) => (lang === 'ar' || lang === 'fa' || lang === 'ur') ? '، ' : ', ';

export const getDayName = (date, lang = 'en') => {
  const list = DAY_NAMES[lang] || DAY_NAMES.en;
  return list[new Date(date).getDay()];
};

// ── Gregorian ↔ Hijri ───────────────────────────────

export const gregorianToHijri = (date, lang = 'en') => {
  try {
    const d = new Date(date);
    const hijri = HijriDate.toHijri(d.getFullYear(), d.getMonth() + 1, d.getDate());
    return {
      day: hijri.hd,
      month: hijri.hm,
      year: hijri.hy,
      monthName: getHijriMonthName(hijri.hm, lang),
    };
  } catch (e) {
    console.error('Hijri conversion error:', e);
    return { day: 1, month: 1, year: 1447, monthName: getHijriMonthName(1, lang) };
  }
};

export const hijriToGregorian = (day, month, year) => {
  try {
    const gregorian = HijriDate.toGregorian(year, month, day);
    return new Date(gregorian.gy, gregorian.gm - 1, gregorian.gd);
  } catch (e) {
    console.error('Gregorian conversion error:', e);
    return new Date();
  }
};

// Get Hijri month name — accepts optional language code
export const getHijriMonthName = (month, lang = 'en') => {
  const list = HIJRI_MONTHS[lang] || HIJRI_MONTHS.en;
  return list[month - 1] || list[0];
};

// Format Hijri date from stored hijriDate object — "Day Month Year"
export const formatHijriFromStored = (hijriDate, lang = 'en') => {
  if (!hijriDate || !hijriDate.day || !hijriDate.month) return '';
  return `${hijriDate.day} ${getHijriMonthName(hijriDate.month, lang)}${hijriDate.year ? ' ' + hijriDate.year : ''}`;
};

// ── Gregorian ↔ Persian (Jalali) ────────────────────

export const gregorianToJalali = (date, lang = 'en') => {
  try {
    const d = new Date(date);
    const { jy, jm, jd } = jalaali.toJalaali(d.getFullYear(), d.getMonth() + 1, d.getDate());
    return { day: jd, month: jm, year: jy, monthName: getPersianMonthName(jm, lang) };
  } catch (e) {
    console.error('Jalali conversion error:', e);
    return { day: 1, month: 1, year: 1404, monthName: getPersianMonthName(1, lang) };
  }
};

export const jalaliToGregorian = (jd, jm, jy) => {
  try {
    const g = jalaali.toGregorian(jy, jm, jd);
    return new Date(g.gy, g.gm - 1, g.gd);
  } catch (e) {
    console.error('Jalali→Gregorian conversion error:', e);
    return new Date();
  }
};

// Get Persian month name — accepts optional language code
export const getPersianMonthName = (month, lang = 'en') => {
  const list = PERSIAN_MONTHS[lang] || PERSIAN_MONTHS.en;
  return list[month - 1] || list[0];
};

export const getJalaliMonthLength = (jy, jm) => jalaali.jalaaliMonthLength(jy, jm);

// Get Gregorian month name — accepts optional language code
export const getGregorianMonthName = (monthIndex, lang = 'en') => {
  const list = GREGORIAN_MONTHS[lang] || GREGORIAN_MONTHS.en;
  return list[monthIndex] || list[0];
};

// ── Formatters — all accept lang parameter ──────────

// "DayName, Day Month Year" — e.g. "Tuesday, 31 March 2026" / "الثلاثاء، ٣١ مارس ٢٠٢٦"
export const formatGregorianDate = (date, lang = 'en') => {
  const d = new Date(date);
  return `${getDayName(d, lang)}${SEP(lang)}${d.getDate()} ${getGregorianMonthName(d.getMonth(), lang)} ${d.getFullYear()}`;
};

// "Day Month Year" (for cards) — no day name
export const formatGregorianDateShort = (date, lang = 'en') => {
  const d = new Date(date);
  return `${d.getDate()} ${getGregorianMonthName(d.getMonth(), lang)} ${d.getFullYear()}`;
};

// "DayName, Day Month Year" — Hijri
export const formatHijriDate = (date, lang = 'en') => {
  const hijri = gregorianToHijri(date, lang);
  return `${getDayName(date, lang)}${SEP(lang)}${hijri.day} ${hijri.monthName} ${hijri.year}`;
};

// "Day Month Year" — Hijri (for cards)
export const formatHijriDateDetailed = (date, lang = 'en') => {
  const hijri = gregorianToHijri(new Date(date), lang);
  return `${hijri.day} ${hijri.monthName} ${hijri.year}`;
};

// "Day Month Year" — Persian (for reminder cards)
export const formatPersianFromStored = (persianDate, lang = 'en') => {
  if (!persianDate || !persianDate.day || !persianDate.month) return '';
  return `${persianDate.day} ${getPersianMonthName(persianDate.month, lang)}${persianDate.year ? ' ' + persianDate.year : ''}`;
};

// "DayName, Day Month Year" — Persian (for home date card)
export const formatPersianDateShort = (date, lang = 'en') => {
  const d = new Date(date);
  const j = gregorianToJalali(d, lang);
  return `${getDayName(d, lang)}${SEP(lang)}${j.day} ${j.monthName} ${j.year}`;
};

// Adjust Hijri date based on settings
export const adjustHijriDate = (date, adjustment) => {
  const adjusted = new Date(date);
  adjusted.setDate(adjusted.getDate() + adjustment);
  return adjusted;
};

// ── Relative time ───────────────────────────────────

export const getNextOccurrence = (reminderDate, repeatYearly = true, hijriDate = null, calendarType = 'gregorian', persianDate = null, repeatFrequency = null) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const date = new Date(reminderDate);

  const freq = repeatFrequency || (repeatYearly ? 'yearly' : 'once');

  if (freq === 'once') return date;

  // ── Weekly: same day-of-week as the original event ─────────────────────
  if (freq === 'weekly') {
    const targetWeekday = date.getDay(); // 0=Sun…6=Sat
    const daysAhead = (targetWeekday - now.getDay() + 7) % 7;
    const result = new Date(now);
    result.setDate(now.getDate() + daysAhead);
    return result;
  }

  // ── Monthly ─────────────────────────────────────────────────────────────
  if (freq === 'monthly') {

    // Hijri monthly: same Hijri day in current / next Hijri month
    if ((calendarType === 'hijri' || calendarType === 'both') && hijriDate?.day && hijriDate?.month) {
      const todayH = gregorianToHijri(now);
      const hDay = parseInt(hijriDate.day);

      // Try current Hijri month
      try {
        const candidate = hijriToGregorian(hDay, todayH.month, todayH.year);
        candidate.setHours(0, 0, 0, 0);
        if (candidate >= now) return candidate;
      } catch (e) { /* try next */ }

      // Next Hijri month
      const nextHMonth = todayH.month === 12 ? 1 : todayH.month + 1;
      const nextHYear  = todayH.month === 12 ? todayH.year + 1 : todayH.year;
      try {
        const candidate = hijriToGregorian(hDay, nextHMonth, nextHYear);
        candidate.setHours(0, 0, 0, 0);
        return candidate;
      } catch (e) { /* fallback */ }
    }

    // Persian monthly: same Persian day in current / next Persian month
    if (calendarType === 'persian' && persianDate?.day && persianDate?.month) {
      const todayJ = gregorianToJalali(now);
      const pDay = parseInt(persianDate.day);

      try {
        const candidate = jalaliToGregorian(pDay, todayJ.month, todayJ.year);
        candidate.setHours(0, 0, 0, 0);
        if (candidate >= now) return candidate;
      } catch (e) { /* try next */ }

      const nextPMonth = todayJ.month === 12 ? 1  : todayJ.month + 1;
      const nextPYear  = todayJ.month === 12 ? todayJ.year + 1 : todayJ.year;
      try {
        const candidate = jalaliToGregorian(pDay, nextPMonth, nextPYear);
        candidate.setHours(0, 0, 0, 0);
        return candidate;
      } catch (e) { /* fallback */ }
    }

    // Gregorian monthly: same day-of-month
    const targetDay = date.getDate();
    const thisMonth = new Date(now.getFullYear(), now.getMonth(), targetDay);
    if (thisMonth >= now) return thisMonth;
    return new Date(now.getFullYear(), now.getMonth() + 1, targetDay);
  }

  // ── Yearly ───────────────────────────────────────────────────────────────
  if ((calendarType === 'hijri' || calendarType === 'both') && hijriDate?.day && hijriDate?.month) {
    const todayHijri = gregorianToHijri(now);
    try {
      const thisYearGreg = hijriToGregorian(hijriDate.day, hijriDate.month, todayHijri.year);
      thisYearGreg.setHours(0, 0, 0, 0);
      if (thisYearGreg >= now) return thisYearGreg;
    } catch (e) { /* try next */ }
    try {
      const nextYearGreg = hijriToGregorian(hijriDate.day, hijriDate.month, todayHijri.year + 1);
      nextYearGreg.setHours(0, 0, 0, 0);
      return nextYearGreg;
    } catch (e) { /* fallback */ }
  }

  if (calendarType === 'persian' && persianDate?.day && persianDate?.month) {
    const todayJ = gregorianToJalali(now);
    try {
      const thisYearGreg = jalaliToGregorian(persianDate.day, persianDate.month, todayJ.year);
      thisYearGreg.setHours(0, 0, 0, 0);
      if (thisYearGreg >= now) return thisYearGreg;
    } catch (e) { /* try next */ }
    try {
      const nextYearGreg = jalaliToGregorian(persianDate.day, persianDate.month, todayJ.year + 1);
      nextYearGreg.setHours(0, 0, 0, 0);
      return nextYearGreg;
    } catch (e) { /* fallback */ }
  }

  const thisYearDate = new Date(now.getFullYear(), date.getMonth(), date.getDate());
  thisYearDate.setHours(0, 0, 0, 0);
  if (thisYearDate >= now) return thisYearDate;
  return new Date(now.getFullYear() + 1, date.getMonth(), date.getDate());
};

export const getRelativeTime = (date, repeatYearly = true, hijriAdjustment = 0, hijriDate = null, calendarType = 'gregorian', persianDate = null, repeatFrequency = null) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  if (hijriAdjustment && (calendarType === 'hijri' || calendarType === 'both')) now.setDate(now.getDate() + hijriAdjustment);
  const targetDate = getNextOccurrence(date, repeatYearly, hijriDate, calendarType, persianDate, repeatFrequency);
  targetDate.setHours(0, 0, 0, 0);
  const diffDays = Math.ceil((targetDate - now) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Tomorrow';
  if (diffDays === -1) return 'Yesterday';
  if (diffDays < 0) return `${Math.abs(diffDays)} days ago`;
  if (diffDays <= 60) return `In ${diffDays} days`;
  if (diffDays <= 365) return `In ${Math.floor(diffDays / 30)} months`;
  return `In ${Math.floor(diffDays / 365)} year${Math.floor(diffDays / 365) > 1 ? 's' : ''}`;
};

export const getRelativeTimeTranslated = (date, repeatYearly, t, hijriAdjustment = 0, hijriDate = null, calendarType = 'gregorian', persianDate = null, repeatFrequency = null) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  if (hijriAdjustment && (calendarType === 'hijri' || calendarType === 'both')) now.setDate(now.getDate() + hijriAdjustment);
  const targetDate = getNextOccurrence(date, repeatYearly, hijriDate, calendarType, persianDate, repeatFrequency);
  targetDate.setHours(0, 0, 0, 0);
  const diffDays = Math.ceil((targetDate - now) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return t('relative.today');
  if (diffDays === 1) return t('relative.tomorrow');
  if (diffDays === -1) return t('relative.yesterday');
  if (diffDays < 0) return t('relative.days_ago', { n: Math.abs(diffDays) });
  if (diffDays <= 60) return t('relative.in_days', { n: diffDays });
  if (diffDays <= 365) return t('relative.in_months', { n: Math.floor(diffDays / 30) });
  return t('relative.in_years', { n: Math.floor(diffDays / 365) });
};

export const getDaysUntilNextYear = (date) => {
  const now = new Date();
  const reminderDate = new Date(date);
  const nextOccurrence = new Date(now.getFullYear() + 1, reminderDate.getMonth(), reminderDate.getDate());
  return Math.ceil((nextOccurrence - now) / (1000 * 60 * 60 * 24));
};

export const hasPassedThisYear = (date) => {
  const now = new Date();
  const reminderDate = new Date(date);
  const thisYearDate = new Date(now.getFullYear(), reminderDate.getMonth(), reminderDate.getDate());
  return thisYearDate < now;
};

// ── Hijri time-since helpers ────────────────────────

export const getPersianTimeSince = (persianDate) => {
  if (!persianDate || !persianDate.day || !persianDate.month || !persianDate.year) return null;
  const todayJ = gregorianToJalali(new Date());
  let years = todayJ.year - persianDate.year;
  let months = todayJ.month - persianDate.month;
  let days = todayJ.day - persianDate.day;
  if (days < 0) { months--; const prevJm = todayJ.month === 1 ? 12 : todayJ.month - 1; const prevJy = todayJ.month === 1 ? todayJ.year - 1 : todayJ.year; days += getJalaliMonthLength(prevJy, prevJm); }
  if (months < 0) { years--; months += 12; }
  if (years < 0) return null;
  return { years, months, days };
};

export const getHijriTimeSince = (hijriDate, hijriAdjustment = 0) => {
  if (!hijriDate || !hijriDate.day || !hijriDate.month || !hijriDate.year) return null;
  const now = new Date();
  if (hijriAdjustment) now.setDate(now.getDate() + hijriAdjustment);
  const todayHijri = gregorianToHijri(now);
  let years = todayHijri.year - hijriDate.year;
  let months = todayHijri.month - hijriDate.month;
  let days = todayHijri.day - hijriDate.day;
  if (days < 0) { months--; days += 30; }
  if (months < 0) { years--; months += 12; }
  if (years < 0) return null;
  return { years, months, days };
};

export const sortRemindersByNextOccurrence = (reminders) => {
  return reminders.sort((a, b) => {
    const aNext = getNextOccurrence(a.date, a.repeatYearly, a.hijriDate, a.calendarType, a.persianDate, a.repeatFrequency);
    const bNext = getNextOccurrence(b.date, b.repeatYearly, b.hijriDate, b.calendarType, b.persianDate, b.repeatFrequency);
    return aNext - bNext;
  });
};

